// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const TEST_ALL_CONFIGS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.TEST_ALL_CONFIGS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Output file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      boolean: {
        kind: 'boolean',
        required: true
      },
      checkbox: {
        kind: 'boolean',
        required: true
      },
      date: {
        kind: 'date',
        required: true
      },
      int: {
        kind: 'integer',
        required: true
      },
      float: {
        kind: 'number',
        required: true
      },
      string: {
        kind: 'string',
        required: true
      },
      enum1: {
        kind: 'enum',
        required: true,
        choices: [
          'BLUE',
          'PINK',
          'PURPLE',
          'GREEN',
          'YELLOW',
          'ORANGE',
          'RED'
        ]
      },
      enum2: {
        kind: 'enum',
        required: true,
        choices: [
          'CIRCLE',
          'DIAMOND',
          'SQUARE',
          'CROSS',
          'X'
        ]
      },
      columnReference: {
        kind: 'columnReference',
        required: true,
        inputDataName: 'Input dataset',
        validationOptions: null
      },
      columnValue: {
        kind: 'anything',
        required: true
      },
      table: {
        kind: 'tableReference',
        required: false,
        inputDataName: 'Input dataset',
        inputDataIndex: 0
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
